const peopleToList = (list) => (list && list.length) ?
    list.map((p) => ({
        id: p.userId,
        label: `${p.name} ${p.lastName ? p.lastName : ""}`
    })) : []

export default peopleToList;
